module.exports = __webpack_public_path__ + "static/media/schedule-view.08179f7a.svg";